export const randomId = () =>
	`exopen-${Math.random().toString(36).slice(2, 11)}`;
